__webpack_require__.p = "/drag-and-drop-mini-project/";